import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsJsonConverterDate, UtilsMisc, UtilsString } from '@pit/core';
import { IDtoResourceCheck } from '../interfaces/dto.resource.check.interface';
import { IDtoUser } from '../interfaces/dto.user.interface';
import { DtoResourceCheckItem } from './dto.resource.check.item';
import { DtoUser } from './dto.user';
import { IDtoResourceCheckItem } from '../interfaces/dto.resource.check.item.interface';
import { IDtoResource } from '../interfaces/dto.resource.interface';
import { DtoResource } from './dto.resource';
import { IDtoMandator } from '../interfaces/dto.mandator.interface';
import { DtoMandator } from './dto.mandator';

// @dynamic
@JsonObject('DtoResourceCheck')
export class DtoResourceCheck extends ModelEntity implements IDtoResourceCheck {

    constructor(initValues: Partial<IDtoResourceCheck> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('checkResult', Number, true)
    public checkResult?: number = 0;

    @JsonProperty('timestamp', UtilsJsonConverterDate, true)
    public timestamp?: Date = null;

    @JsonProperty('deviceId', String, true)
    public deviceId?: string = null;

    @JsonProperty('resourceCode', String, true)
    public resourceCode?: string = null;

    @JsonProperty('resourceId', String, true)
    public resourceId?: string = null;

    @JsonProperty('resourceTypeCode', String, true)
    public resourceTypeCode?: string = null;

    @JsonProperty('resourceTypeDescription', String, true)
    public resourceTypeDescription?: string = null;

    @JsonProperty('userName', String, true)
    public userName?: string = null;

    @JsonProperty('userNumber', String, true)
    public userNumber?: string = null;

    @JsonProperty('mandator', DtoMandator, true)
    public mandator?: IDtoMandator = null;

    @JsonProperty('items', [DtoResourceCheckItem], true)
    public items?: IDtoResourceCheckItem[] = [];

    public getHasFaults(): boolean {
        return ((UtilsMisc.isNullOrUndefined(this.items) === false) && (this.items.length > 0) &&
            (UtilsMisc.isNullOrUndefined(this.items.find(x => (x.isFault === true))) === false));
    }

}
